import cx from 'classnames';

import cypressIds from 'Components/cypress_ids.json';
import { getExteriorGradeText } from 'Components/pages/VehicleDetailsRedesign/sections/ConditionAndDamageSection/Components/VehicleDetailsExteriorGrading/ExteriorGrading/ExteriorGrading.helpers';
import { ExteriorGradingModal } from 'Components/pages/VehicleDetailsRedesign/sections/ConditionAndDamageSection/Components/VehicleDetailsExteriorGrading/ExteriorGrading/ExteriorGradingModal/ExteriorGradingModal';
import { VehicleSpecsDetailsButton } from 'Components/pages/VehicleDetailsRedesign/sections/MotSection/VehicleSpecsDetailsButton/VehicleSpecsDetailsButton';
import type { GradingValues, VehicleMainInfo } from 'Pages/vehicles/helpers/vehicle.schema';
import { triggerGradingModalOpenedOrClosedEvent } from 'Services/analytics/events';
import { applyCypressData } from 'Utilities/helpers';

import styles from './VehicleDetailsExteriorGrading.module.scss';

interface VehicleDetailsExteriorGradingProps {
	exteriorGrade: GradingValues;
	vehicleSpec: Pick<VehicleMainInfo, 'make' | 'model'>;
}

export const VehicleDetailsExteriorGrading: React.FC<VehicleDetailsExteriorGradingProps> = ({
	exteriorGrade,
	vehicleSpec,
}) => {
	return (
		<div className={cx(styles.container)} {...applyCypressData(cypressIds.containers.gradingModal)}>
			{getExteriorGradeText(exteriorGrade)}
			<VehicleSpecsDetailsButton
				cypressId={cypressIds.links.gradingDetails}
				modal={<ExteriorGradingModal exteriorGrade={exteriorGrade} vehicleSpec={vehicleSpec} />}
				onModalClose={() => {
					triggerGradingModalOpenedOrClosedEvent(false);
				}}
				onModalOpen={() => {
					triggerGradingModalOpenedOrClosedEvent(true);
				}}
			/>
		</div>
	);
};
